<template>
  <div id="playlist-recent-songs">
    <h4>Recent Songs</h4>
    <Vuetable
      data-path="songs"
      pagination-path="pagination"
      ref="vuetable"
      :data="data"
      :api-mode="false"
      :fields="fields"
      :css="css.table"
      :per-page="10"
      @vuetable:pagination-data="onPaginationData">

      <!-- Preview -->
      <template slot="preview" slot-scope="props">
        <vue-plyr :ref="`plyr-${props.rowData.id}`">
          <audio :id="props.rowData.id">
            <source :src="props.rowData.url" type="audio/mp3" />
          </audio>
        </vue-plyr>
      </template>

      <!-- Action -->
      <template slot="action" slot-scope="props">
        <b-button
          variant="success"
          @click="checkSong(props.rowData)"
          :disabled="playlistSongIds.includes(props.rowData.id)"
          block>
          Add
        </b-button>
      </template>

      <!-- Length -->
      <template slot="length" slot-scope="props">
        {{ formatTime(props.rowData.length) }}
      </template>
    </Vuetable>

    <!-- Pagination -->
    <div class="d-flex align-items-center justify-content-end">
      <VuetablePaginationInfo ref="paginationInfo" />
      <VuetablePagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
        :css="css.pagination"
      />
    </div>
  </div>
</template>

<script>

  import TableStyle from '../table-bootstrap-css.js';
  export default {
    props : {
      data : {
        type : Object,
      },
    },
    data() {
      return {
        loading : false,
        css     : TableStyle,
        fields  : [ {
          name      : '__slot:action',
          dataClass : 'text-center',
        }, {
          name  : 'title',
          title : 'Title',
        }, {
          name  : 'album',
          title : 'Album',
        }, {
          name       : '__slot:preview',
          title      : 'Preview',
          titleClass : 'text-center',
          dataClass  : 'text-center',
        }, {
          name       : '__slot:length',
          title      : 'Length',
          titleClass : 'text-center',
          dataClass  : 'text-center',
        } ],
      }
    },
    computed : {
      playlistSongIds() {
        return this.$store.getters['playlist/playlistSongIds'];
      },
    },
    components : {
      'Vuetable'           : () => import('vuetable-2/src/components/Vuetable'),
      'VuetablePagination' :
        () => import('vuetable-2/src/components/VuetablePagination'),
      'VuetablePaginationInfo' :
        () => import('vuetable-2/src/components/VuetablePaginationInfo'),
    },
    methods : {

      /**
       * Check if Song is already added
       * @param data
       */
      checkSong(data) {
        const isAdded = this.playlistSongIds.includes(data.id);

        if (!isAdded)
          this.addToPlaylist(data.id);
        else {
          this.$modal.show('dialog', {
            title   : 'Duplicate Song',
            text    : `<b>${data.title}</b> is already in your playlist`,
            buttons : [{
              title : 'Skip Duplicate',
            }],
          });
        }
      },

      /**
       * Add Song to Playlist
       * @param musicId
       */
      addToPlaylist(musicId) {
        this.$http.post('api/playlist/song', {
          mPlaylistId : this.$route.params.playlistId,
          musicId     : musicId,
        }).then(() => {
          this.$store.dispatch(
            'playlist/getPlaylistSongIds',
            this.$route.params.playlistId);
          this.$emit('song-added');
          this.$notify({
            group : 'notif',
            type  : 'success',
            title : 'Success',
            text  : 'Added song successfully!',
          });
        }).catch(() => {
          this.$notify({
            group : 'notif',
            type  : 'failed',
            title : 'Failed',
            text  : 'Oops! Something went wrong!',
          });
        });
      },

      /**
       * Update Paginaton info
       * @param paginationData
       */
      onPaginationData(paginationData) {
        this.$nextTick(() => {
          this.$refs.pagination.setPaginationData(paginationData);
          this.$refs.paginationInfo.setPaginationData(paginationData);
        });
      },

      /**
       * Update Vuetable page
       * @param page
       */
      onChangePage(page) {
        this.$nextTick(() => {
          this.$refs.vuetable.changePage(page);
        });
      },

      /**
       * Format Song Length
       * @param value
       */
      formatTime(value) {
        let result = '';
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value - (hours * 3600)) / 60);
        let seconds = value - (hours * 3600) - (minutes * 60);

        // round seconds & exclude remainder
        seconds = parseInt(Math.round(seconds * 100) / 100);

        if (hours > 0) {
          result = (hours < 10 ? '0' + hours : hours) +
            ':' + (minutes < 10 ? '0' + minutes : minutes) +
            ':' + (seconds < 10 ? '0' + seconds : seconds);
        } else {
          result = (minutes < 10 ? '0' + minutes : minutes) + ':' +
            (seconds < 10 ? '0' + seconds : seconds);
        }

        return result;
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>